// How long a widget waits for its translated copy before it gives up
// and paints in English. Translated copy runs meaningfully longer than
// the English defaults, so painting before it arrives means painting
// twice and moving the page underneath the visitor.
//
// Every widget that renders translated copy is expected to wait for the
// same length of time, because they all share one request for the file.
export const LOCALE_STRINGS_TIMEOUT_MS = 1_500
